import React, { useState } from 'react';
import { color } from '@/theme';
import styled from '@emotion/styled';
import { Checkbox, FormHelperText } from '@mui/material';
import { PrivacyPolicyModal } from '@/components/modal';
import { FormattedMessage, useIntl } from 'react-intl';
import TermsConditionsModal from '@/components/modal/TermsConditionsModal';

const Wrapper = styled.div(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '1rem 0.2rem',
  marginTop: '2.4rem',
  padding: '1rem 0 0',
  flexWrap: 'wrap',
}));

const CheckboxInput = styled(Checkbox)(() => ({
  width: '2rem',
  height: '2rem',
  marginRight: '0.4rem',
  color: color.base_black,

  '& .MuiSvgIcon-root': {
    fontSize: '2rem',
  },

  '&.Mui-checked': {
    color: color.base_purple,
  },
}));

const TermText = styled.label(() => ({
  cursor: 'pointer',
  textDecoration: 'underline',
}));

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

const InquiryTerms = ({ checked, setChecked, errors, setValue }) => {
  const intl = useIntl();

  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isTermsOpen, setIsTermsOpen] = useState(false);

  const handlePrivacyPolicyClick = () => {
    // Privacy Policy 클릭 시 처리할 로직
    setIsPrivacyOpen(true);
  };

  const handleTermsConditionsClick = () => {
    // Terms & Conditions 클릭 시 처리할 로직
    setIsTermsOpen(true);
  };

  return (
    <>
      <Wrapper>
        <CheckboxInput
          {...label}
          value={checked}
          id="terms"
          size="small"
          onChange={(e) => {
            setChecked(e.target.checked);
            setValue('term', e.target.checked, { shouldValidate: true });
          }}
        />

        <FormattedMessage
          id="lang-terms-agree"
          defaultMessage="I have read and agree to the {privacyPolicy} and {termsConditions}."
          values={{
            privacyPolicy: (
              <TermText onClick={handlePrivacyPolicyClick}>
                {intl.formatMessage({
                  id: 'lang-privacy-policy',
                  defaultMessage: 'Privacy Policy',
                })}
              </TermText>
            ),
            termsConditions: (
              <TermText onClick={handleTermsConditionsClick}>
                {intl.formatMessage({
                  id: 'lang-terms',
                  defaultMessage: 'Terms & Conditions',
                })}
              </TermText>
            ),
          }}
        />
      </Wrapper>

      <FormHelperText error>{errors.term ? errors.term.message : ''}</FormHelperText>

      <PrivacyPolicyModal openModal={isPrivacyOpen} setOpenModal={setIsPrivacyOpen} />

      <TermsConditionsModal openModal={isTermsOpen} setOpenModal={setIsTermsOpen} />
    </>
  );
};

export default InquiryTerms;
